import * as dayjs from "dayjs";

/**
 * Add a log entry to a document's log array
 * @param {Object} params - Log parameters
 * @param {string} params.action - The action being logged (e.g., "status_changed", "created", "updated")
 * @param {string} params.user - Email or identifier of the user performing the action
 * @param {any} params.oldValue - Previous value (optional)
 * @param {any} params.newValue - New value (optional)
 * @param {Object} params.metadata - Additional metadata (optional)
 * @returns {Object} Log entry object
 */
export const createLogEntry = ({ action, user, oldValue = null, newValue = null, metadata = null }) => {
  const logEntry = {
    action,
    timestamp: dayjs().unix(),
    user,
  };

  if (oldValue !== null) {
    logEntry.oldValue = oldValue;
  }

  if (newValue !== null) {
    logEntry.newValue = newValue;
  }

  if (metadata !== null) {
    logEntry.metadata = metadata;
  }

  return logEntry;
};

/**
 * Add a log entry to an existing log array
 * @param {Array} existingLog - Current log array
 * @param {Object} logParams - Parameters for createLogEntry
 * @returns {Array} Updated log array
 */
export const addLogEntry = (existingLog = [], logParams) => {
  const newEntry = createLogEntry(logParams);
  return [...existingLog, newEntry];
};
